<template>
  <div>
    <h1 class="m-b-40">{{ t('skjalaundirsida_header') }}</h1>

      <SkjolTable />

  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import SkjolTable from '@/components/Joakim/SkjolTable.vue'

// import IFrameLanaSkjol from '@/components/coredata/fiveDegrees/IFrameLanaSkjol.vue'

const { t } = useI18n()

// Active tab state
const activeTab = ref(0)
</script>
